import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, Component, Input, Optional } from "@angular/core";
import { NzButtonGroupComponent } from "ng-zorro-antd/button";
import { UiButtonGroupSize } from "../../models/button.models";

@Component({
  selector: "ui-button-group",
  exportAs: "uiButtonGroup",
  templateUrl: "./button-group.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiButtonGroupComponent extends NzButtonGroupComponent {
  @Input("uiSize") public nzSize: UiButtonGroupSize = "default";

  constructor(@Optional() directionality: Directionality) {
    super(directionality);
  }
}
